<template>
  <page-header-wrapper>
    <div class="back-content">
      <a-tabs
        class="back-content-tabs"
        :default-active-key="selectedTab"
        :active-key="selectedTab"
        :animated="false"
        @change="tabChange"
      >
        <a-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :tab="tab.title"
        >
          <component :is="tab.component" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </page-header-wrapper>
</template>

<script>
import PlanIncome from './planIncome/PlanIncome.vue'
import TotalIncome from './totalIncome/TotalIncome.vue'

const settingTabs = [
  {
    title: '均摊收入（未税）',
    key: 'totalIncome',
    component: 'TotalIncome'
  },
  {
    title: '均摊计提（含税）',
    key: 'planIncome',
    component: 'PlanIncome'
  }
]

export default {
  components: {
    PlanIncome,
    TotalIncome
  },
  data () {
    return {
      tabs: settingTabs,
      selectedTab: ''
    }
  },
  watch: {
    '$route.query.tab': {
      handler: function (val) {
        this.setSelectedTab()
      }
    }
  },
  created () {
    this.setSelectedTab()
  },
  methods: {
    setSelectedTab () {
      if (this.$route.query && this.$route.query.tab) {
        this.selectedTab = this.$route.query.tab
      } else {
        this.selectedTab = this.tabs[0].key
      }
    },
    tabChange (activeKey) {
      this.$router.push({
        name: 'shareIncome',
        query: {
          tab: activeKey
        }
      })
    }
  }
}
</script>
